// extracted by mini-css-extract-plugin
export default {"componentWrapper":"OrderHeader_componentWrapper__VrkXw","label":"OrderHeader_label__Y0KG8","title":"OrderHeader_title__mGSmz"};